export function dollarFormatter(num, fractionDigits = 0) {
  let safeNum = num;
  if (typeof num === "undefined") {
    return "";
  }
  if (typeof safeNum === "string") {
    safeNum = parseFloat(safeNum);
  }
  if (safeNum === null) {
    return "$0";
  }
  if (isNaN(safeNum)) {
    return "$0";
  }
  return `$${safeNum.toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
}
